import { Action } from 'redux';

export const RELOAD_HEADER = 'RELOAD_HEADER';
export type ReloadHeaderAction = Action<typeof RELOAD_HEADER>;

export const RELOAD_HEADER_SUCCESS = 'RELOAD_HEADER_SUCCESS';
export type ReloadHeaderSuccessAction = Action<typeof RELOAD_HEADER_SUCCESS>;

export const SET_STICKY_MODE = 'SET_STICKY_MODE';
export type SetStickyModeAction = {
    type: typeof SET_STICKY_MODE;
    payload: boolean;
};

export type HeaderAction = ReloadHeaderAction | ReloadHeaderSuccessAction | SetStickyModeAction;
